/* eslint-disable */
import React, { Component } from 'react';
import { VenuePlan } from '../';
import { EventDatePriceListModel } from '../../../mvcapi/models/buyticket/ticketpriceselection';

var tr = require('ts-translate-js').default.boundTR;


export type VenuePlanKitProps = {
    packageKit: {
        packageID: number,
        eventDateIDs: number[]
    },
    selectedEventDate: EventDatePriceListModel,
    afterSearchTickets: Function,
    processing: boolean
}

export type VenuePlanKitState = {
}


export class VenuePlanKit extends Component<VenuePlanKitProps, VenuePlanKitState> {
    private searchTicketRequest: any;

    static defaultProps = {
        packageKit: {
            packageID: null,
            eventDateIDs: []
        }
    }

    constructor(props) {
        super(props);
    }

    getVenueImageURL(venueModelId) {
        return tsapp.ctlPath + `/VenuePlan/LoadVenuePlanByVenueModelID?VenueModelID=` + venueModelId;
    }

    handleVenuePlanSearchTicket(packageKit, selectedEventDateID, nbTickets, atPosition, planEngine){
        if(packageKit.packageID != null)
            this.searchTicketRequest = tsapp.mvcapi.postCtl("ticket/searchpackageticketatpinpoint", { packageID: packageKit.packageID,
                                                                                                      eventDateIDs: packageKit.eventDateIDs,
                                                                                                      selectedEventDateID: selectedEventDateID,
                                                                                                      nbOfTickets: nbTickets,
                                                                                                      point: { X: atPosition.x, Y: atPosition.y }})
                                            .success(function (data) {
                                                this.props.afterSearchTickets();
                                            }.bind(this));
        else
            this.searchTicketRequest = tsapp.mvcapi.postCtl("ticket/searchticketatpinpoint", { eventDateID: selectedEventDateID, nbOfTickets: nbTickets, point: { X: atPosition.x, Y: atPosition.y } })
                                        .success(function (data) {
                                            this.props.afterSearchTickets();
                                        }.bind(this));
        // SearchTicketAtPinpoint(int eventDateID, int nbOfTickets, Vector2 point)

        // planEngine.pointSomethingAt(pointOnPlan)
    }

    render() {
        var selectedItemForPlan = null;
        const isInMultiEventMode = this.props.packageKit.packageID != null;

        if(this.props.selectedEventDate != null) {
            if(this.props.selectedEventDate.VenuePlanInfo.planAvailable)
                selectedItemForPlan = {
                    packageKit: this.props.packageKit,
                    eventDateID: this.props.selectedEventDate.EventDateID,
                    tickets: this.props.selectedEventDate.Tickets,
                    planInfo: this.props.selectedEventDate.VenuePlanInfo
                };
        }

        // If we want to see a plan for one of the event date
        var planCtl = null;
        if(selectedItemForPlan !== null) {
            // Create the action menu
            var planContextMenu = {
                items: [
                    {
                        text: tr('venueplan.contextmenu.lookfortickethere'),
                        action: (pointOnPlan, planEngine) => this.handleVenuePlanSearchTicket(selectedItemForPlan.packageKit, selectedItemForPlan.eventDateID, selectedItemForPlan.tickets.length, pointOnPlan, planEngine)
                    },
                    {
                        text: tr('venueplan.contextmenu.cancel'),
                        action: (pointOnPlan, planEngine) => {}
                    }
                ]
            };

            planCtl = (
                <div className={isInMultiEventMode ? "col-sm-12 col-lg-12" : "col-sm-12 col-lg-4"}>
                    <VenuePlan
                        eventDateId={this.props.selectedEventDate ? this.props.selectedEventDate.EventDateID : undefined}
                        venueImageURL={this.getVenueImageURL(selectedItemForPlan.planInfo.venueModelId)}
                        tickets={selectedItemForPlan.tickets}
                        planInfo={selectedItemForPlan.planInfo}
                        contextMenu={planContextMenu}
                        processing={this.props.processing}
                        engineSettings={{ showDebugInfo: false }}
                        remoteControl={null}
                    />
                </div>
            );

        }

        return planCtl;
    }
};
